<div class="sales-volume-history-page-container container" fxLayout="column" fxLayoutGap="15px">
  <p>{{ 'SALES_VOLUME_INFO' | translate }}</p>
  <p class="color-muted">
    {{ 'PREFERENCES_TEXT' | translate }} <strong style="color: white">{{volumeDisplayValue}}</strong>
    {{ 'EST_SALES_VOLUME' | translate }}, {{ 'USING' | translate }} <strong style="color: white">{{areaDisplayValue}}</strong>
    {{ 'TO_CALCULATE' | translate }}.
  </p>
  <hr />
  <div class="text-center color-muted" *ngIf="!dataSource?.data.length">
    {{ 'NO_VOLUME_ESTIMATES' | translate }}
  </div>
  <div class="table-container container condensed-table">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="volumeDate" matSortDirection="desc"
           *ngIf="dataSource?.data.length">
      <ng-container matColumnDef="volumeDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ESTIMATE_DATE' | translate }}</th>
        <td mat-cell *matCellDef="let volume">
          <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
            <span>{{volume.date | insightsDate}}</span>
            <mtn-sales-volume-tag [volume]="volume"></mtn-sales-volume-tag>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="salesVolume">
        <th class="column-right" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">
          {{ 'EST_SALES_VOLUME' | translate }}
        </th>
        <td class="column-right" mat-cell *matCellDef="let volume">
          <div fxLayout="row" fxLayoutAlign="end start">
            <mtn-sales-volume-view [volume]="volume" [includeSuffix]="false"
                                   *ngIf="volume.total; else notPurchased"></mtn-sales-volume-view>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="salesSqft">
        <th class="column-right" mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">
          {{ 'EST_SALES_SQFT' | translate }}
        </th>
        <td class="column-right" mat-cell *matCellDef="let volume">
          <div fxLayout="row" fxLayoutAlign="end start">
            <mtn-sales-sqft-view [volume]="volume" [includeSuffix]="false"
                                 *ngIf="volume.salesSqft; else doubleDash"></mtn-sales-sqft-view>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    <mat-paginator [pageSize]="5" [showFirstLastButtons]="true" [length]="dataSource.data?.length"
                   [hidePageSize]="true" [hidden]="dataSource.data?.length <= 5"></mat-paginator>
  </div>
</div>

<ng-template #notPurchased>
  <span class="color-muted">{{ 'NOT_PURCHASED' | translate }}</span>
</ng-template>

<ng-template #doubleDash>
  <span class="color-muted">--</span>
</ng-template>
